import { render, staticRenderFns } from "./ProductGroupEditor.vue?vue&type=template&id=7b4d3fa8&"
import script from "./ProductGroupEditor.vue?vue&type=script&lang=js&"
export * from "./ProductGroupEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports